<div>
  @if (orderDetails$ | async; as orderDetails) {
    <div class="d-block d-lg-flex mt-1 justify-content-center align-items-center">
      <div class="item-details d-flex flex-column align-items-center flex-grow-1 flex-shrink-1 p-3">
        <div class="d-lg-flex d-block">
          <div>
            @if (firstBasketItem$ | async; as firstBasketItem) {
              @switch (firstBasketItem.ItemType) {
                @case (basketItemType.Reward) {
                  <ng-container *ngTemplateOutlet="rewardsTemplate; context: { $implicit: firstBasketItem }"></ng-container>
                }
                @case (basketItemType.PortalProduct) {
                  <ng-container
                    *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'products.purchase.success' | translate,
                        message: 'products.purchase.email.confirmation' | translate,
                      }
                    "
                  ></ng-container>
                }

                @default {
                  <ng-container
                    *ngTemplateOutlet="
                      messageTemplate;
                      context: {
                        title: 'default.purchase.success' | translate,
                        message: 'default.purchase.email.confirmation' | translate,
                      }
                    "
                  ></ng-container>
                }
              }
            }

            <div class="d-flex justify-content-between border-0 mt-4">
              <a class="btn btn-primary confirm-btn fw-bold" [routerLink]="['/rewards/wallet']">{{
                'rewards.back.to.wallet' | translate
              }}</a>
            </div>
          </div>

          <div class="border rounded payment-details">
            @if (basketItems$ | async; as basketItems) {
              @if (basketItems.length > 0) {
                @for (basket of basketItems; track basket.BasketKind) {
                  @for (item of basket.Items; track item.Id) {
                    <div class="d-lg-flex d-block">
                      <div class="me-4">
                        <img
                          class="purchase-success-image rounded"
                          src="{{ item.Image | contentImage: '7' : 'marketplace' }}"
                          alt="{{ item.Image }}"
                          [useDefault]="true"
                          loyaltyType="marketplace"
                          draggable="false"
                        />
                      </div>
                      <div class="mt-3 mt-lg-0">
                        <ng-container>
                          <div class="font-size-14 fw-bold mb-3">
                            {{ item.Title || 'Display Name' }}
                          </div>
                        </ng-container>

                        <!--Quantity-->
                        <div class="d-flex align-items-center mt-2">
                          <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.quantity' | translate }}</span>
                          <span class="fw-bold font-size-14">{{ item.Quantity }}</span>
                        </div>

                        <!-- Points -->
                        <div class="d-flex align-items-center mt-2">
                          <span class="font-size-12 rewards-details-spacing">{{ 'marketplace.points.used' | translate }}</span>
                          <span *ngIf="item.Points > 0" class="fw-bold font-size-14"
                            >{{ item.Points / 100 | number }} {{ 'fgbcl.currency.pts' | translate }}</span
                          >
                          <span *ngIf="item.Points == 0" class="fw-bold font-size-14">
                            {{ 'fgbcl.marketplace.item.free' | translate }}</span
                          >
                        </div>
                      </div>
                    </div>
                  }
                }
              } @else {
                <div class="text-center m-5">{{ 'no.purchased.item.found' | translate }}</div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  }
</div>

<!-- Generic Message Template -->
<ng-template #messageTemplate let-title="title" let-message="message">
  <div class="text-success mb-0 fw-bold font-size-18 text-left">
    {{ title }}
  </div>
  <p class="mb-0 text-black font-size-14 text-left pe-lg-4 rewards-success-description">
    {{ message }}
  </p>
</ng-template>

<!-- Rewards Template -->
<ng-template #rewardsTemplate let-reward>
  @switch (reward.SubItemType) {
    @case (marketplaceSubType.MarketplaceItem) {
      <ng-container
        *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'marketplace.purchase.success' | translate,
            message: 'marketplace.purchase.email.confirmation' | translate,
          }
        "
      ></ng-container>
    }
    @case (marketplaceSubType.UniqueCode) {
      <ng-container
        *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'unique.code.purchase.success' | translate,
            message: 'unique.code.purchase.email.confirmation' | translate,
          }
        "
      ></ng-container>
    }
    @case (marketplaceSubType.DownloadLink) {
      <ng-container
        *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'download.purchase.success' | translate,
            message: 'download.purchase.email.confirmation' | translate,
          }
        "
      ></ng-container>
    }
    @case (marketplaceSubType.Event) {
      <ng-container
        *ngTemplateOutlet="
          messageTemplate;
          context: {
            title: 'events.purchase.success' | translate,
            message: 'events.purchase.email.confirmation' | translate,
          }
        "
      ></ng-container>
    }
  }
</ng-template>
